import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAuth0 } from '@auth0/auth0-angular';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { appRoutes } from './app.routes';
import { environment } from '../environments/environment';
import { initializeUser } from './services/user-initializer';
import { UserService } from './services/user.service';
import { MobileAuthInterceptor } from './interceptors/mobile-auth.interceptor';

/**
 * Client config — includes Auth0, APP_INITIALIZER, and BrowserAnimationsModule.
 * Firebase providers are added in main.ts. Server uses app.config.server.ts instead.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: MobileAuthInterceptor, multi: true },
    importProvidersFrom([BrowserAnimationsModule, TranslateModule.forRoot()]),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideAuth0({
      domain: environment.auth0Domain,
      clientId: environment.auth0ClientId,
      authorizationParams: {
        redirect_uri: typeof window !== 'undefined' ? `${window.location.origin}/auth-callback` : 'https://www.crickteams.com/auth-callback',
        audience: environment.auth0ApiAudience
      },
      cacheLocation: 'localstorage',
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeUser,
      deps: [UserService],
      multi: true
    }
  ]
};
